/**
 * 会员类型
 */
export enum MemberType {
  /**
   * 个人会员
   */
  PERSON = 0,

  /**
   * 企业会员
   */
  ENTERPRISE = 1
}

export const MemberTypeTextMap = {
  [MemberType.PERSON]: '个人会员',
  [MemberType.ENTERPRISE]: '企业会员'
}
